module.exports = __webpack_public_path__ + "media/sora.6636f7a1.wav";